export const properties = {
  deyalaSecureURL: 'https://deyala-api.officeblaze.com/api/secure/v1',
  deyalaPublicURL: 'https://deyala-api.officeblaze.com/api/public/v1' 
  // deyalaSecureURL: 'http://localhost:8088/api/secure/v1',
  // deyalaPublicURL: 'http://localhost:8088/api/public/v1'
  // deyalaSecureURL: 'http://10.0.2.2:8088/api/secure/v1',
  // deyalaPublicURL: 'http://10.0.2.2:8088/api/public/v1'
};

